import React, { useEffect, useState } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import "./BrandsSubCategories.scss";
import slugme from "slugme";
import { withTranslation } from "react-i18next";
import BrandsHeader from "../BrandsHeader/BrandsHeader";
import images from "../../../../ressources/images";
import { getBrandsSubCategories } from "../../../../api/brands";
import InsLoader from "../../../../components/InsLoader/InsLoader";
import { saveGoBackPage } from "../../../../utils/history";
import LazyLoadBackgroundImage from "components/LazyLoadBackgroundImage/LazyLoadBackgroundImage";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ArticleElement = ({ image, title, id, brandId }) => {
  return (
    <Link
      to={{
        pathname: "/articles/" + brandId + "/" + id,
      }}
    >
      <LazyLoadBackgroundImage src={image} alt="" className="element-spacing">
        <div className="element">
          <span className="element__icon article"></span>
          <span className="element__title">{title}</span>
        </div>
      </LazyLoadBackgroundImage>
    </Link>
  );
};

const VideoElement = ({ image, title, brandId, youtube_id: youtubeId, id }) => {
  return (
    <Link
      to={{
        pathname: "/brands/videos/" + brandId + "/watch=" + youtubeId,
        state: { id: id },
      }}
    >
      <LazyLoadBackgroundImage src={image} alt="" className="element-spacing">
        <div className="element">
          <span className="element__icon video"></span>
          <span className="element__title">{title}</span>
        </div>
      </LazyLoadBackgroundImage>
    </Link>
  );
};

const CourseElement = ({
  image,
  title,
  coursePoints,
  courseProgress,
  id,
  courseTime,
}) => {
  // let status;
  const formationSlug = slugme(title) + "-" + id;

  const history = useHistory();

  return (
    <Link
      to={{
        pathname: "/formations/" + formationSlug,
        // state: { prev: history.location.pathname },
      }}
      onClick={() => saveGoBackPage(history.location.pathname)}
    >
      <LazyLoadBackgroundImage src={image} alt="" className="element-spacing">
        <div className="element">
          <span className="element__icon formation"></span>
          <span className="element__points">
            +{coursePoints} <img src={images.points_stars} alt="" />
          </span>
          <span className="element__title">{title}</span>
          <div className={"element__progress__container"}>
            <div className="element__progress">
              <div
                className="element__progress__bar"
                style={{ width: courseProgress + "%" }}
              ></div>
            </div>
            <div className="formation_time">
              <div className="time">{courseTime}</div>
            </div>
          </div>
        </div>
      </LazyLoadBackgroundImage>
    </Link>
  );
};

const ProductElement = ({ image, title, pdf, link, file }) => {
  let mediaUrl = `${window.location.origin.toString()}`;
  mediaUrl = mediaUrl.replace("://", "://media-") + "/";
  const [iframe, setiframe] = useState(false);
  const [contentHeight] = useState(window.innerHeight);

  const openIframe = () => {
    setiframe(true);
    document.getElementsByClassName("brands-sub-categories")[0].scrollTo(0, 0);
    document.getElementsByClassName("brands-sub-categories")[0].style.overflow =
      "hidden";
  };

  return (
    <>
      {link ? (
        <div className="productlist_link">
          <LazyLoadBackgroundImage
            src={image}
            alt=""
            className="element-spacing"
          >
            <div className="element" onClick={openIframe}>
              <span className="element__icon produit"></span>
              <span className="element__title">{title}</span>
            </div>
          </LazyLoadBackgroundImage>
          {iframe && (
            <>
              <div className="close_iframe_container">
                <button
                  className="close_iframe"
                  onClick={() => setiframe(false)}
                ></button>
              </div>
              <iframe
                src={link}
                id="catalog"
                style={{ height: contentHeight - 120 }}
                frameBorder="0"
                scrolling="yes"
                title="catalog"
              ></iframe>
            </>
          )}
        </div>
      ) : (
        <Link
          className="productlist_link"
          to={{
            pathname: mediaUrl + file,
            state: { transitionName: "slide_in" },
          }}
          target="_blank"
        >
          <LazyLoadBackgroundImage
            src={image}
            alt=""
            className="element-spacing"
          >
            <div className="element">
              <span className="element__icon produit"></span>
              <span className="element__title">{title}</span>
            </div>
          </LazyLoadBackgroundImage>
        </Link>
      )}
    </>
  );
};

const Element = (props) => {
  switch (props.type) {
    case "video":
      return <VideoElement {...props} />;

    case "course":
      return <CourseElement {...props} />;

    case "product_catalog":
      return <ProductElement {...props} />;

    case "article":
    default:
      return <ArticleElement {...props} />;
  }
};

const SubCategory = (props) => {
  return (
    <div className="sub-category">
      <span className="sub-category__title">{props.name}</span>
      <div className="sub-category__list">
        {props.content.map((element) => (
          <Element
            {...element}
            key={element.type + "-" + element.id}
            brandId={props.brandId}
          />
        ))}
      </div>
    </div>
  );
};

const BrandsSubCategories = (props) => {
  const { brandId, categoryId } = props.match.params;

  const [subCategories, setsubCategories] = useState([]);

  useEffect(() => {
    apiGetBrandsSubCategories();
  }, [brandId, categoryId, props.i18n.language]);

  const apiGetBrandsSubCategories = () => {
    getBrandsSubCategories(brandId, categoryId).then((data) => {
      setsubCategories(data);
    });
  };

  const backPage = `/brands/categories/${brandId}`;
console.log(subCategories)
  return subCategories ? (
    <>
      <BrandsHeader
        history={props.history}
        logo={subCategories.logoNoir}
        back={backPage}
      />
      <div className="brands-sub-categories">
        <div className="brands-sub-categories__list">
          {subCategories?.map((subCategory) => {
            if (0 === subCategory.content.length) {
              return <></>;
            }

            return (
              <SubCategory
                {...subCategory}
                key={subCategory.id}
                brandId={brandId}
              />
            );
          })}
        </div>
      </div>
    </>
  ) : (
    <InsLoader />
  );
};

export default withRouter(withTranslation()(BrandsSubCategories));
